import { createSlice } from '@reduxjs/toolkit';

interface AgentPanelState {
    isOpen: boolean;
    isDragging: boolean;
    pendingMessage: string | null;
}

const initialState: AgentPanelState = {
    isOpen: false,
    isDragging: false,
    pendingMessage: null,
};

export const agentConversationPanelSlice = createSlice({
    name: 'agentConversationPanel',
    initialState,
    reducers: {
        openAgentConversationPanel: (state) => {
            state.isOpen = true;
        },
        // Opens the panel and hands it a message to auto-send once it's mounted — used by
        // entry points outside the panel itself (e.g. the Dashboard composer/suggestion chips)
        // that can't reach the panel's own local message state directly.
        openAgentConversationPanelWithMessage: (state, action) => {
            state.isOpen = true;
            state.pendingMessage = action.payload;
        },
        clearPendingAgentMessage: (state) => {
            state.pendingMessage = null;
        },
        closeAgentConversationPanel: (state) => {
            state.isOpen = false;
        },
        toggleAgentConversationPanel: (state) => {
            state.isOpen = !state.isOpen;
        },
        setAgentPanelDragging: (state, action) => {
            state.isDragging = action.payload;
        },
    },
});

export const { openAgentConversationPanel, openAgentConversationPanelWithMessage, clearPendingAgentMessage, closeAgentConversationPanel, toggleAgentConversationPanel, setAgentPanelDragging } =
    agentConversationPanelSlice.actions;
export default agentConversationPanelSlice.reducer;
